import {
  GeneralButtonActionEvent,
  GeneralToggleSetStateEvent,
  LimitStatus,
  PremiumFeature,
  PurchaseOpenAccountPlanUpgradeEvent,
  Screen,
  trackEvent,
  UIElementID,
  UIInteractionType,
  UpgradePlanType,
  UpgradeTrigger,
} from '@otter-ai/telemetry';

export const trackDropboxMain = {
  connectDropbox: () => {
    trackEvent(
      GeneralButtonActionEvent({
        Screen: Screen.apps,
        UIElementID: UIElementID.appsDropboxConnect,
        UIInteractionType: UIInteractionType.primaryActivate,
      }),
    );
  },

  disconnectDropbox: () => {
    trackEvent(
      GeneralButtonActionEvent({
        Screen: Screen.apps,
        UIElementID: UIElementID.appsDropboxDisconnect,
        UIInteractionType: UIInteractionType.secondaryActivate,
      }),
    );
  },

  dropboxToggleAutoExport: (isStateOn: boolean) => {
    trackEvent(
      GeneralToggleSetStateEvent({
        Screen: Screen.apps,
        UIElementID: UIElementID.appsDropboxToggleAutoExport,
        IsStateOn: isStateOn,
      }),
    );
  },

  openModifyExportSettings: () => {
    trackEvent(
      GeneralButtonActionEvent({
        Screen: Screen.apps,
        UIElementID: UIElementID.appsDropboxModifyDefaultExportSettings,
        UIInteractionType: UIInteractionType.secondaryActivate,
      }),
    );
  },

  dropboxPlanUpgrade: () => {
    trackEvent(
      PurchaseOpenAccountPlanUpgradeEvent({
        UpgradePlanType: UpgradePlanType.team,
        PremiumFeature: PremiumFeature.allowDropboxSync,
        LimitStatus: LimitStatus.limitReached,
        UpgradeTrigger: UpgradeTrigger.featureInteraction,
      }),
    );
  },
} as const;

export const trackDropbox = {
  main: trackDropboxMain,
} as const;
